(() => {
  function initialise(root) {
    if (root.dataset.funnelInitialised) return;
    root.dataset.funnelInitialised = 'true';
    const lifecycle = new AbortController();
    root.carlsFunnelDestroy = () => lifecycle.abort();
    const on = (target, type, listener) => target.addEventListener(type, listener, { signal: lifecycle.signal });
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    const copy = JSON.parse($('[data-funnel-copy]').textContent);
    const text = (key, vars = {}) => Object.entries(vars).reduce((s,[k,v]) => s.replaceAll(`{${k}}`,String(v)),copy[key] ?? key);
    const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
    let state = JSON.parse(root.dataset.funnelState || '{"pouches":0,"servings":0,"goal":4,"tiers":[]}');
    const track = (event, extra={}) => window.hugosTrack?.(event,{step:'meat',servings:state.servings,pouches:state.pouches,goal_servings:state.goal*2,box_value:Number.isFinite(state.price)?state.price/100:null,subscription:true,...extra});
    const put = (selector,value) => { const el=$(selector); if(el) el.textContent=value; };
    function sync() {
      const tiers=(state.tiers || []).sort((a,b)=>a.pouches-b.pouches), starter=tiers[0];
      const current=tiers.find(t=>t.pouches===state.pouches);
      const next=tiers.find(t=>t.pouches>state.pouches && (!current || t.unit<current.unit));
      const filling=current || next || starter;
      const more=next ? next.pouches*2-state.servings : 0;
      const complete=Boolean(current && state.available);
      let title=text('starter_prompt'),detail=text('pouch_tip');
      if(starter && state.pouches<4) {
        title=state.pouches ? text('need_start',{more:8-state.servings,total:money(starter.price)}) : text('starting_summary',{price:money(starter.price)});
        detail=text('unit',{price:money(starter.unit)})+' · '+text('pouch_tip');
      } else if(next) {
        title=text('unlock',{more,unit:money(next.unit)});
        detail=(current ? money(current.unit)+' → '+money(next.unit)+' · ' : '')+text('unlock_detail',{servings:next.pouches*2,total:money(next.price)});
      } else if(current) {
        title=text('best',{unit:money(current.unit)});
        detail=text('selection',{servings:state.servings,pouches:state.pouches})+' · '+money(current.price)+' '+text('first_box');
      }
      put('[data-picker-value-title]',title);put('[data-picker-value-detail]',detail);
      put('[data-mobile-value-hint]',title);
      const progress=$('[data-picker-progress]'), target=next ? next.pouches*2 : filling ? filling.pouches*2 : 8;
      progress.setAttribute('aria-valuemax',String(target));progress.setAttribute('aria-valuenow',String(Math.min(state.servings,target)));
      progress.setAttribute('aria-label',text('progress',{servings:state.servings,target}));progress.firstElementChild.style.width=`${Math.min(100,state.servings/target*100)}%`;
      $$('[data-funnel-size-choice]').forEach(button=>{
        const size=Number(button.dataset.funnelSizeChoice);
        button.setAttribute('aria-pressed',String(size===state.goal));
        button.classList.toggle('is-filled',state.pouches>=size);
        button.disabled=Boolean(state.busy);
      });
      if(filling) {
        put('[data-first-total]',money(filling.price));
        put('[data-total-label]',current ? text('first_box') : text('pending_total',{servings:filling.pouches*2}));
        put('[data-serving-price]',money(filling.unit));
      }
      put('[data-mobile-count]',state.pouches ? text('selection',{servings:state.servings,pouches:state.pouches}) : text('starting_box'));
      put('[data-mobile-price]',current ? money(current.price)+' · '+text('unit',{price:money(current.unit)}) : filling ? text('pending_price',{total:money(filling.price),servings:filling.pouches*2}) : text('available_sizes'));
      if(!state.busy && state.pouches<4) $$('[data-checkout]').forEach(button=>{
        button.disabled=!state.ready && (complete || !next);
        button.textContent=state.ready ? text('checkout',{price:money(state.price)}) : complete ? text('unavailable') : state.pouches===0 ? text('choose_meat') : next ? text('add_more',{more}) : text('unavailable');
      });
      const renewal=$('[data-renewal-copy]');
      put('[data-mobile-terms]',state.ready && renewal?.textContent ? renewal.textContent : text('cart_terms'));
      if(state.pouches>=4 && !current && next && !state.checkoutError) put('[data-checkout-status]',text('fill_total',{servings:next.pouches*2,total:money(next.price)})+'. '+text('pouch_tip')+'.');
      document.querySelectorAll('[data-funnel-resume-label]').forEach(el=>el.textContent=text(state.pouches?'continue_box':'hero_cta'));
      const barTitle=document.querySelector('[data-funnel-bar-title]'),barSub=document.querySelector('[data-funnel-bar-sub]');
      if(barTitle && state.pouches){barTitle.textContent=text('sticky_resume',{servings:state.servings});barSub.textContent=current?money(current.price)+' · '+text('first_box'):text('sticky_finish');}
      else if(barTitle){barTitle.textContent=barTitle.dataset.initialText;barSub.textContent=text('sticky_qualifier');}
    }
    on(root,'carls:funnel-state',event=>{state=event.detail;sync();});
    on(root,'click',event=>{
      const button=event.target.closest('button');if(!button || button.disabled)return;
      if(button.hasAttribute('data-funnel-size-choice')){
        const pouches=Number(button.dataset.funnelSizeChoice);
        document.dispatchEvent(new CustomEvent('hugos:goal',{detail:{pouches}}));
        track('hugos_box_size_select');
        if(pouches>state.pouches && pouches>4) track('carls_box_upgrade_intent',{goal_servings:pouches*2});
      }
      if(button.hasAttribute('data-checkout') && !state.configured && !state.busy){
        if(root.classList.contains('summary-open'))$('[data-summary-close]')?.click();
        document.dispatchEvent(new CustomEvent('carls:filter',{detail:{meat:'all'}}));
        const card=$$('.cb-card').find(el=>el.dataset.available==='true' && !el.hidden);
        card?.scrollIntoView({block:'center',behavior:'instant'});card?.querySelector('[data-plus]')?.focus({preventScroll:true});
        track('carls_continue_selection');
      }
      if(button.hasAttribute('data-review'))track('carls_box_summary_toggle',{expanded:button.getAttribute('aria-expanded')==='true'});
    });
    on(document,'carls:funnel-open',event=>{
      $('#cb-title')?.focus({preventScroll:true});
      root.closest('.survey-overlay-panel')?.scrollTo({top:0,behavior:'instant'});
      if(event.detail?.flavour)requestAnimationFrame(()=>{const card=$$('.cb-card').find(el=>el.dataset.id===event.detail.flavour);if(card && !card.hidden)card.scrollIntoView({block:'start',behavior:'instant'});});
      sync();track('carls_funnel_step_view');
    });
    const barTitle=document.querySelector('[data-funnel-bar-title]');if(barTitle)barTitle.dataset.initialText=barTitle.textContent;
    sync();
  }
  function start(){
    document.querySelectorAll('.fn-builder').forEach(initialise);
    const bar=document.querySelector('[data-funnel-shop-bar]'),hero=document.querySelector('[data-funnel-hero]');
    if(!bar || !hero || bar.dataset.initialised)return;
    bar.dataset.initialised='true';let ticking=false;
    const update=()=>{const final=document.querySelector('.c9-final');bar.hidden=hero.getBoundingClientRect().bottom>0 || Boolean(final && final.getBoundingClientRect().top<innerHeight);ticking=false;};
    document.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
    window.addEventListener('resize',update,{passive:true});update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);document.addEventListener('carls:catalog-ready',start);
})();
